export default __webpack_public_path__ + "static/media/overviewBg.e22d7d5f.png";